module.exports = __webpack_public_path__ + "static/media/02290012-aiD0wSgs.f22d6aa2.JPG";